import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#fff"
        d="M10 2.667H3.333v10.666h9.334v-8H10V2.667zm-8-.672c0-.366.298-.662.666-.662h8L14 4.667v9.328a.666.666 0 01-.662.672H2.662A.667.667 0 012 14.005V1.995zM7.333 10h1.334v1.333H7.333V10zm0-5.333h1.334v4H7.333v-4z"
      ></path>
    </svg>
  )
}

export default Icon
